<template>
	<div class="brand-info-banner">
		<div class="banner-title">Satisfy all your cravings at once!</div>
		<div class="banner-text">
			<p>Add items from any brand menus to your order</p>
			<p>Everything will arrive together</p>
		</div>
	</div>
</template>

<style scoped>
.brand-info-banner {
	background: var(--gR-base-90);
	padding: 28px 26px;
	width: 100%;
}
.banner-title {
	font-weight: var(--sk-font-bold);
	color: var(--gR-white);
	font-size: 18px;
	margin-bottom: 15px;
}
.banner-text p {
	font-size: 14px;
	margin: 0px;
	color: var(--gR-white);
}
</style>

<script>
export default {
	name: "BrandInfoBanner"
}
</script>